import {
  get,
  TextHeading,
  Box,
  TextBody,
  Space,
  Link,
} from '@ally/metronome-ui'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { DrawerProps } from './index'

const StyledTextHeading = styled(TextHeading)`
  margin-bottom: ${get.space('sm')};
`

export const DownloadPanel = ({
  children,
  onClose,
}: DrawerProps): React.ReactElement => {
  const { id } = useParams<{ id: string }>()
  const [initialLoad, setInitialLoad] = useState(true)

  /*
   * Trigger the Panel to close and the Form to reset
   * when the account is switched but not on initial load
   */
  useEffect(() => {
    /* istanbul ignore next */
    if (!initialLoad) {
      onClose()
    }
    setInitialLoad(false)
  }, [id])

  return (
    <Box data-testid="download-container">
      <StyledTextHeading size="xs" focusOnMount>
        Download Account Activity
      </StyledTextHeading>
      <Space mb="md">
        <TextBody tag="p" size="sm">
          You can download up to 18 months of transactions. View transactions
          for the past 7 years in{' '}
          <Link to="/bank/statements-and-forms" text="Statements" />.
        </TextBody>
      </Space>
      {children}
    </Box>
  )
}
